<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item><a style="font-weight: 700; color: #333;">个人中心</a></el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div class="list">
        <div class="item">
          <div class="item-fl">
            <div class="item-fl-title">用户名</div>
            <div class="item-fl-content">{{ $store.state.nickName || '--' }}</div>
          </div>
        </div>
        <div class="item">
          <div class="item-fl">
            <div class="item-fl-title">单位</div>
            <div class="item-fl-content">{{ $store.state.unitName || '--' }}</div>
          </div>
        </div>
        <div class="item">
          <div class="item-fl">
            <div class="item-fl-title">邮箱</div>
            <div class="item-fl-content">{{ $store.state.toEmail || '--' }}</div>
          </div>
        </div>
        <div class="item">
          <div class="item-fl">
            <div class="item-fl-title">手机号码</div>
            <div class="item-fl-content">已绑定手机号：{{ $store.state.phone }}</div>
          </div>
          <div class="item-fr" @click="phoneInfo.dialogVisible = true">修改</div>
        </div>
        <div class="item">
          <div class="item-fl">
            <div class="item-fl-title">账户密码</div>
            <div class="item-fl-content">密码：******</div>
          </div>
          <div class="item-fr" @click="userInfo.dialogVisible = true">修改</div>
        </div>
      </div>
    </el-card>

    <el-dialog title="修改密码" :visible.sync="userInfo.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="closeUerInfo">
      <el-form :model="userInfo" :rules="rules" ref="infoRef" label-width="90px" class="demo-ruleForm" >
        <!-- <el-form-item label="旧密码" prop="oldPwd">
          <el-input autocomplete="new-password" :type="oldPwd" v-model.trim="userInfo.oldPwd" maxlength="16" placeholder="请输入旧密码">
            <i slot="suffix" class="cursor" :class="oldPwd == 'password'? 'iconfont icon-xianshi': 'iconfont icon-yincang'" @click="handleShow(1, oldPwd)"></i>
          </el-input>
        </el-form-item> -->
        <el-form-item label="新密码" prop="newPwd">
          <el-input autocomplete="new-password" :type="newPwd" v-model.trim="userInfo.newPwd" maxlength="16" placeholder="请输入新密码（8-16位数字大小写字母组合）">
            <i slot="suffix" class="cursor" :class="newPwd == 'password'? 'iconfont icon-xianshi': 'iconfont icon-yincang'" @click="handleShow(2, newPwd)"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPwds">
          <el-input autocomplete="new-password" :type="newPwds" v-model.trim="userInfo.newPwds" maxlength="16" placeholder="确认密码">
            <i slot="suffix" class="cursor" :class="newPwds == 'password'? 'iconfont icon-xianshi': 'iconfont icon-yincang'" @click="handleShow(3, newPwds)"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userInfo.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="userInfo.loading" @click="handleSubmit" >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改手机号" :visible.sync="phoneInfo.dialogVisible" :append-to-body="true" :close-on-click-modal="false" @close="closePhoneInfo">
      <el-form :model="phoneInfo" :rules="rules" ref="phoneInfoRef" label-width="90px" class="demo-ruleForm" >
        <el-form-item label="旧手机号" prop="oldPhone">
          <el-input type="text" v-model.trim="phoneInfo.oldPhone" maxlength="11" placeholder="请输入旧手机号">
          </el-input>
        </el-form-item>
        <el-form-item label="新手机号" prop="newPhone">
          <el-input type="text" v-model.trim="phoneInfo.newPhone" maxlength="11" placeholder="请输入新手机号">
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code" style="position: relative;">
          <el-input  v-model.trim="phoneInfo.code" placeholder="请输入短信验证码" maxlength="6"></el-input>
          <div class="box" v-if="disabled"><span style="cursor: pointer;" @click.stop="getCode">{{btnTxt}}</span></div>
          <div class="box" v-if="!disabled"><span style="color: #999;">{{txt}}</span></div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="phoneInfo.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="phoneInfo.loading" @click="handlePhoneInfoSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <Verificate :isShow="isShow" @success="successVer()" @cancel="cancleVer()"></Verificate>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { AdminUpdatePwds, LoginGetPhoneMa, systemPhoneRevamp } from '@/api/system'
import Verificate from '@/components/verificate/Verificate'
export default {
  components: { Verificate },
  data () {
    const checkPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if (!reg.test(value)) {
          callback(new Error('密码格式为8-16位数字大小写字母组合'))
        } else {
          callback()
        }
      }
    }
    const checkPPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if (!reg.test(value)) {
          callback(new Error('密码格式为8-16位数字大小写字母组合'))
        } else {
          callback()
        }
      }
    }
    const checkPPwds = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userInfo.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isShow: false,
      oldPwd: 'password',
      newPwd: 'password',
      newPwds: 'password',
      userInfo: {
        dialogVisible: false,
        loading: false,
        oldPwd: '',
        newPwd: '',
        newPwds: ''
      },
      rules: {
        oldPwd: [{ required: true, validator: checkPwd, trigger: 'blur' }],
        newPwd: [{ required: true, validator: checkPPwd, trigger: 'blur' }],
        newPwds: [{ required: true, validator: checkPPwds, trigger: 'blur' }],
        oldPhone: [
          { required: true, message: '请输入旧手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        newPhone: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      phoneInfo: {
        dialogVisible: false,
        loading: false,
        oldPhone: '',
        newPhone: '',
        code: ''
      },
      disabled: true,
      btnTxt: '获取验证码',
      txt: ''
    }
  },
  created() {
  },
  methods: {
    // 获取短信验证码 1、 唤起滑块校验
    getCode () {
      this.$refs.phoneInfoRef.validateField('newPhone', valid => {
        if (valid) return false
        this.isShow = true
      })
    },
    successVer() {
      this.isShow = false
      LoginGetPhoneMa({ mobile: this.phoneInfo.newPhone }).then((res) => {
        if (res.code === '000') {
          this.$message.success('验证码发送成功')
          this.time = 60
          this.disabled = false
          this.timer()
        }
      })
    },
    cancleVer () {
      this.isShow = false
    },
    // 计时器
    timer () {
      if (this.time > 0) {
        this.time--
        this.txt = this.time + 's'
        setTimeout(this.timer, 1000)
      } else {
        this.btnTxt = '重新获取'
        this.disabled = true
        this.time = 0
      }
    },
    handlePhoneInfoSubmit() {
      this.$refs.phoneInfoRef.validate((valid) => {
        if (!valid) return false
        const params = {
          mobileTo: this.phoneInfo.oldPhone,
          mobile: this.phoneInfo.newPhone,
          valCode: this.phoneInfo.code
        }
        this.phoneInfo.loading = true
        systemPhoneRevamp(params).then(res => {
          this.phoneInfo.loading = false
          if (res.code === '000') {
            this.$message.success('修改成功')
            this.phoneInfo.dialogVisible = false
            setTimeout(() => {
              window.sessionStorage.clear()
              this.$router.push({ path: '/login' })
            }, 1500)
          }
          if (res.code == '904') {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 修改手机号
    closePhoneInfo() {
      this.$refs.phoneInfoRef.resetFields()
      this.phoneInfo.loading = false
      this.phoneInfo.oldPhone = ''
      this.phoneInfo.newPhone = ''
      this.phoneInfo.code = ''
      this.disabled = true
      this.btnTxt = '获取验证码'
      this.txt = ''
    },
    // 修改密码
    closeUerInfo() {
      this.$refs.infoRef.resetFields()
      this.userInfo.loading = false
      this.userInfo.oldPwd = ''
      this.userInfo.newPwd = ''
      this.userInfo.newPwds = ''
    },
    handleSubmit () {
      this.$refs.infoRef.validate((valid) => {
        if (!valid) return false
        this.userInfo.loading = true
        const params = {
          id: this.$store.state.id,
          // newPassword: this.userInfo.oldPwd
          newPassword: md5(this.userInfo.newPwd)
        }
        AdminUpdatePwds(params).then(res => {
          this.userInfo.loading = false
          if (res.code == '000') {
            this.$message.success('修改成功')
            this.userInfo.dialogVisible = false
          }
        })
      })
    },
    handleShow(index, type) {
      switch (index) {
        case 1:
          if (type == 'password') {
            this.oldPwd = 'text'
          } else {
            this.oldPwd = 'password'
          }
          break
        case 2:
          if (type == 'password') {
            this.newPwd = 'text'
          } else {
            this.newPwd = 'password'
          }
          break
        case 3:
          if (type == 'password') {
            this.newPwds = 'text'
          } else {
            this.newPwds = 'password'
          }
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .list {
    padding: 0 10px 50px;
    box-sizing: border-box;
    .item {
      border-bottom: 1px solid #e5e6eb;
      padding: 20px 0;
      display: flex;
      align-items: center;
      .item-fl {
        flex: 1;
        .item-fl-title {
          font-size: 16px;
          color: #000;
          font-weight: 700;
        }
        .item-fl-content {
          margin-top: 15px;
          color: #7B7B7B;
        }
      }
      .item-fr {
        cursor: pointer;
        color: #2784EC;
      }
    }
  }
  .box::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 16px;
  top: 12px;
  left: 0;
  background: #D8D8D8;
}
.box {
  width: 120px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  font-size: 14px;
  color: #2A73FF;
}
</style>
